<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			If “Yes,” please complete question below
		</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Insurance in Force</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaExtra" class="mt6" />
		<case-form :schema="schemaPending" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			If “Yes,” please complete question below
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Insurance Applied For</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPendingList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaExtra2" class="mt6" />
		<case-form :schema="schemaDeclined" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			If “Yes,” please complete question below
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Application Declined</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaDeclinedList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `Do you have Life Insurance In Force?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLifeInsurance`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsurance`
						},
						createOptions: {
							type: `hasLifeInsurance`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Total insurance in force (USD)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalInsuranceInForce`,
					props: {
						suggest: {
							typeIncludes: `totalInsuranceInForce`
						},
						createOptions: {
							type: `totalInsuranceInForce`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaPending() {
			return [
				{
					label: `Do you have any applications for life insurance currently pending or contemplated? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLifeInsurancePending`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsurancePending`
						},
						createOptions: {
							type: `hasLifeInsurancePending`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Total insurance pending with all companies (USD)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalInsurancePending`,
					props: {
						suggest: {
							typeIncludes: `totalInsurancePending`
						},
						createOptions: {
							type: `totalInsurancePending`,
							dataType: "number"
						}
					}
				},
				{
					label:
						"Of the amount pending, how much do you intend to accept? (USD)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceAmountIntendToAccept`,
					props: {
						suggest: {
							typeIncludes: `insuranceAmountIntendToAccept`
						},
						createOptions: {
							type: `insuranceAmountIntendToAccept`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaExtra() {
			return [
				{
					label: `Do you plan to replace, change, or use values from any existing insurance as a source of premium payment
for any life insurance coverage that may be applied for?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToReplaceOrChangeExistingLifeInsurance`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToReplaceOrChangeExistingLifeInsurance`
						},
						createOptions: {
							type: `hasPlanToReplaceOrChangeExistingLifeInsurance`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If “Yes,” please provide details:`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0replaceOrChangeOfLifeInsuranceDetails`,
					props: {
						suggest: {
							typeIncludes: `replaceOrChangeOfLifeInsuranceDetails`
						},
						createOptions: {
							type: `replaceOrChangeOfLifeInsuranceDetails`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaExtra2() {
			return [
				{
					label: `What is the ultimate total amount to be placed in all companies (including existing in force life insurance coverage)?  `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0ultimateTotalLine`,
					props: {
						suggest: {
							typeIncludes: `ultimateTotalLine`
						},
						createOptions: {
							type: `ultimateTotalLine`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaDeclined() {
			return [
				{
					label: `Have you ever had any applications for life, disability, critical illness, health or long term care insurance declined,
rated, postponed, cancelled or modified in any way?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasInsuranceApplicationDeclined`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationDeclined`
						},
						createOptions: {
							type: `hasInsuranceApplicationDeclined`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Details`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasInsuranceApplicationDeclinedDetails`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationDeclinedDetails`
						},
						createOptions: {
							type: `hasInsuranceApplicationDeclinedDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaList(i) {
			return [
				{
					label: `Name of Insurance Company`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCompany${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCompany${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceCompany${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCity${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCity${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `State/Province`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceStateOrProvince${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceStateOrProvince${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceStateOrProvince${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCountry${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount of Coverage in Force`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceCoverageAmount${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceCoverageAmount${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceCoverageAmount${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Year of Issue`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceYearOfIssue${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceYearOfIssue${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceYearOfIssue${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Type of Insurance`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0currentLifeInsuranceType${i}`,
					props: {
						suggest: {
							typeIncludes: `currentLifeInsuranceType${i}`
						},
						createOptions: {
							type: `currentLifeInsuranceType${i}`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaPendingList(i) {
			return [
				{
					label: `Name of Insurance Company`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCompany${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCompany${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceCompany${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCity${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCity${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceCity${i}`,
							dataType: "string"
						}
					}
				},

				{
					label: `State/Province`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceStateOrProvince${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceStateOrProvince${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceStateOrProvince${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCountry${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount of Coverage in Force`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceCoverageAmount${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceCoverageAmount${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceCoverageAmount${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of Application`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingLifeInsuranceApplicationDate${i}`,
					props: {
						suggest: {
							typeIncludes: `pendingLifeInsuranceApplicationDate${i}`
						},
						createOptions: {
							type: `pendingLifeInsuranceApplicationDate${i}`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaDeclinedList(i) {
			return [
				{
					label: `Year of Application`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationYear${i}`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationYear${i}`
						},
						createOptions: {
							type: `declinedApplicationYear${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Insurance Company`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationInsuranceCompany${i}`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationInsuranceCompany${i}`
						},
						createOptions: {
							type: `declinedApplicationInsuranceCompany${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Product Applied For`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationProduct${i}`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationProduct${i}`
						},
						createOptions: {
							type: `declinedApplicationProduct${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Decision and Reason`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0declinedApplicationReason${i}`,
					props: {
						suggest: {
							typeIncludes: `declinedApplicationReason${i}`
						},
						createOptions: {
							type: `declinedApplicationReason${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
